/** Default empty-field glyph for *Presenter default slot content. */

export const PRESENTER_VALUE_FALLBACK = '―';
